import React from 'react';
import AppLoaderSmorgDefault from './app_loader_smorg_default';
import AppLoaderSpaceSplashPage from './app_loader_space_splash_page';
import { useIsMobile } from './layout_hooks';
import {
  useGetEndUserSpaceQuery,
  useGetUserProfileQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { userIsCreator } from '../../services/users';

const AppLoader = () => {
  const { data: userProfile } = useGetUserProfileQuery();

  const isSmorgStudio = userIsCreator(userProfile);

  const { data: currentSpace } = useGetEndUserSpaceQuery(undefined, {
    skip: !userProfile || isSmorgStudio,
  });

  const isMobile = useIsMobile();

  const splashImageUrl = currentSpace?.whiteLabelElements?.splashImageUrl;

  if (isMobile && splashImageUrl) {
    return <AppLoaderSpaceSplashPage splashImageUrl={splashImageUrl} />;
  }

  return <AppLoaderSmorgDefault />;
};

export default AppLoader;
